import React from 'react';
import cn from 'classnames';
import { getLocalImageUrl } from 'utils/image';
import {
  alternateSignUpButtonLabel,
  alternateSignUpUrl,
  alternateSignUpVideo,
} from 'constants/alternateSignUp';
import styles from './AlternateSignUp.module.sass';

export interface AlternateSignUpProps {
  onLoginClick: () => void;
}

const ALTERNATE_SIGN_UP_FEATURES = [
  'Our NEWEST UGC creators plus professional studio photo and video',
  'Access to international creators',
  'Content for Amazon, Shopify, TikTok, Meta, and more',
  'One platform for every type of branded content',
  'And more!',
];

const AlternateSignUp: React.FC<AlternateSignUpProps> = ({ onLoginClick }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.logoRow}>
          <img
            className={styles.trendLogo}
            src={getLocalImageUrl('images/trend-logo-black.svg')}
            alt="Trend"
          />
          <span className={styles.logoArrow} aria-hidden>
            →
          </span>
          <img
            className={styles.soonaLogo}
            src={getLocalImageUrl('images/soona-logo.svg')}
            alt="soona"
          />
        </div>
        <div className={styles.content}>
          <h1 className={styles.headline}>
            Trend joined soona. All your content needs are now in one place.
          </h1>
          {alternateSignUpVideo ? (
            <div className={styles.videoWrapper}>
              {alternateSignUpVideo}
              <video>
                <source src="" />
              </video>
              <span>A 60 second note from Trend&apos;s cofounder.</span>
            </div>
          ) : (
            <div className={styles.featureContent}>
              <p className={cn(styles.introCopy, 'DM-Sans', 'text-size-regular')}>
                Everything you know about creating a campaign on Trend is now
                available on soona, along with new tools, more creators, and more
                ways to produce content.
              </p>
              <ul className={styles.featureList}>
                {ALTERNATE_SIGN_UP_FEATURES.map((feature) => (
                  <li key={feature} className={styles.featureItem}>
                    <span className={styles.featureCheck} aria-hidden>
                      <i className="icon-check-filled" />
                    </span>
                    <span
                      className={cn(
                        styles.featureText,
                        'text-weight-bold'
                      )}
                    >
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <a
          className={cn(styles.ctaButton, 'DM-Sans', 'text-weight-bold')}
          href={alternateSignUpUrl}
          target="_blank"
          rel="noopener"
        >
          <span>{alternateSignUpButtonLabel}</span>
          <i className="icon-arrow-forward-filled" aria-hidden />
        </a>
      </div>
      <p className={cn(styles.loginPrompt, 'DM-Sans', 'text-size-regular')}>
        Already have a Trend account?{' '}
        <button
          type="button"
          className={cn(styles.loginLink, 'VG5000', 'sans-serif')}
          onClick={onLoginClick}
        >
          Log In
        </button>
      </p>
    </div>
  );
};

export default AlternateSignUp;
